import * as React from 'react'; 
import styled from 'styled-components';

import { SVG } from '@longline/aqua-ui/svg';

import { useGlobalState } from '../../../contexts/state/GlobalStateContext';
import { Icon } from '@longline/aqua-ui/controls/Icon';

interface IProps {
  /** @ignore */
  className?: string;
  /** @ignore */
  children?: React.ReactNode;
  /** Is the pane expandable? */
  expandable?: boolean;
  /** Optional action button */
  action?: React.ReactNode;
}

const PaneSubheaderBase = (props: IProps) => {
  const globalState = useGlobalState();
  return (
    <div className={props.className}>
      <Left>
        {props.action}
        <Title>{props.children}</Title>
      </Left>
      {props.expandable &&
        <Icon size="large" mirrored={globalState.expanded} url={SVG.Icons.Expand} onClick={globalState.togglePaneExpansion}/>}
    </div>
  )
}

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  overflow: hidden;
  padding-left: 2px;
  height: 50px;
`

const Title = styled.div`
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`

const PaneSubheaderStyled = styled(PaneSubheaderBase)`
  position: relative;
  height: 60px;
  min-height: 60px;
  flex: 0;
  box-sizing: border-box;
  background-color: ${p => p.theme.colors.primary[5]};
  padding: 0 30px 0 30px;
  box-sizing: border-box;
  display: flex;
  align-items: center;  
  justify-content: space-between;
  user-select: none;
  gap: 16px;
  & > * { flex-shrink: 0 }
`

const PaneSubheader = (props: IProps) => <PaneSubheaderStyled {...props}/>

export { PaneSubheader }
